export default function polygonToString(p: TPolygon) {
	const str = p.type;
	const coordsString = p.coords.map((point) => `(${point[0]}, ${point[1]})`).join(", ");

	return `${str}: ${coordsString}`;
}
